/* eslint-disable no-unused-expressions */
/* eslint-disable no-underscore-dangle */
/* eslint-disable class-methods-use-this */

const ATTR_DISABLED = "disabled";
const ATTR_NAME = "default-value";
const ATTR_ERROR_MESSAGE = "error-message";

class SwitchLgpd extends HTMLElement {
  get css() {
    return `
      .container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        margin: 8px 0px;
        text-align: left;
      }
      .container h2 {
        width: 100%;
        font-size: 20;
        font-weight: bold;
        font-style: normal;
        margin: 8px 0;
        color: #494949;
        line-height: 14px;
      }
      .indicator {
        margin: 3px 0px;
        width: 20px;
        height: 5px;
        background-color: #005FC8
      }
      .container p {
        font-size: 16;
        font-weight: 300;
        font-style: normal;
        margin: 8px 0;
        color: #525252;
        line-height: 18px;
      }
      .container .switch {
        display: flex;
        flex-grow: 1;
        flex-direction: row;
        align-items: space-around;
        justify-content: center;
        border: 1px solid #D1DBE3;
        margin: 13px 0;
        width: 300px;
        height: 40px;
      }
      .container .switch input {
        display: none;
      }
      .divider {
        display: flex;
        flex-grow: 1;
        flex-direction: column;
        border: 0.5px solid #D1DBE3;
        background: #D1DBE3;
        width: 1px;
        height: 99%;
      }
      .container .switch #yes-button:checked+label  {
        background: #005FC8;
        color: #FFFFFF;
      }
      .container .switch #no-button:checked+label  {
        background: #005FC8;
        color: #FFFFFF;
      }
      .container .switch label {
        display: flex;
        flex-direction: column;
        align-items: space-around;
        justify-content: space-around;
        text-align: center;
        cursor: pointer;
        background: transparent;
        color: #005FC8;
        user-select: none;
        width: 100%;
      }
      .footer {
        display: none;
        position: relative;
        bottom: 0;
        width: 100%;
        text-align: left;
      }
      .show {
        display: block;
      }
      .error {
        color: red;
        font-size(11);
        text-align: left;
      }
      @media (max-width: 767px) {
        .container h2 {
          font-size: 16;
        }
        .container .switch {
          width: 100%;
        }
      }
    `;
  }

  get template() {
    return `<style>${this.css}</style>
      <div class="container">
        <h2>Quer receber novidades?</h2>
        <div class="indicator"></div>
        <p>Sempre que houver novidades, ofertas e promoções de nossos serviços, sejam das
        empresas do nosso grupo ou de parceiros, gostaríamos de te avisar através dos seus contatos
        cadastrados. Assim, você não perde nenhuma oportunidade.</p>
        <div class="switch">
          <input
            id="yes-button"
            type="radio"
            name="switcher"
            value="1"
          />
          <label for="yes-button">Sim</label>
          <div class="divider"></div>
          <input
            id="no-button"
            type="radio"
            name="switcher"
            value="0"
          />
          <label for="no-button">Não</label>
        </div>
        <div class="footer">
          <span class="error">Campo Obrigatório</span>
        </div>
      </div>
    `;
  }

  constructor() {
    super();
    this._disabled = false;
    this._defaultValue = null;
    this._errorMessage = null;
    this._shadowRoot = this.attachShadow({ mode: "open" });
    this._shadowRoot.innerHTML = this.template;
  }

  static get observedAttributes() {
    return [ATTR_DISABLED, ATTR_NAME, ATTR_ERROR_MESSAGE];
  }

  connectedCallback() {
    this._disabled = this.getAttribute(ATTR_DISABLED) !== null;
    this._defaultValue = this.getAttribute(ATTR_NAME);
    this._errorMessage = this.getAttribute(ATTR_ERROR_MESSAGE);

    if (this._disabled) {
      this.handleDisabled();
    }

    this.handleInputValue();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === ATTR_NAME) {
      this._defaultValue = newValue;
      this.handleInputValue();
    }

    if (name === ATTR_DISABLED) {
      this._disabled = newValue !== null;
      this.handleDisabled();
    }

    if (name === ATTR_ERROR_MESSAGE) {
      this._errorMessage = newValue;
      if (this._errorMessage) {
        this.showErrorMessage();
      } else {
        this.hiddenErrorMessage();
      }
    }
  }

  handleInputValue() {
    this._shadowRoot.querySelectorAll("input").forEach((input) => {
      input.addEventListener("change", (e) => this.handleOnChange(e));

      input.getAttribute("value") === this._defaultValue
        ? input.setAttribute("checked", true)
        : input.removeAttribute("checked");
    });
  }

  handleOnChange(event) {
    if (this._disabled) {
      event.stopImmediatePropagation();
    } else {
      this.dispatchEvent(
        new CustomEvent("onChange", {
          detail: { value: event.target.value },
        })
      );
    }
  }

  handleDisabled() {
    this._shadowRoot
      .querySelectorAll("input")
      .forEach((input) =>
        this._disabled
          ? input.setAttribute(ATTR_DISABLED)
          : input.removeAttribute(ATTR_DISABLED)
      );
  }

  showErrorMessage() {
    this._shadowRoot.querySelector(".footer").classList.add("show");
  }

  hiddenErrorMessage() {
    this._shadowRoot.querySelector(".footer").classList.remove("show");
  }
}

window.customElements.define("switch-lgpd", SwitchLgpd);
